import { useEffect, useState } from 'react';

import {
  type EmailCrawlerSource,
  resolveEmailCrawlerSourceByFolder,
} from './email-crawler-api';
import {
  type KnownCrawlerFolder,
  findKnownCrawlerFolder,
} from './email-crawler-folders';

interface UseEmailCrawlerSourceResult {
  source: EmailCrawlerSource | null;
  knownFolder: KnownCrawlerFolder | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function useEmailCrawlerSourceByFolder(
  apiBaseUrl: string,
  prefix: string | null,
): UseEmailCrawlerSourceResult {
  const [source, setSource] = useState<EmailCrawlerSource | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const knownFolder = findKnownCrawlerFolder(prefix);

  const refresh = async () => {
    if (!prefix) {
      setSource(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await resolveEmailCrawlerSourceByFolder(apiBaseUrl, prefix);
      setSource(result.source ?? null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to resolve crawler source');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void refresh();
  }, [apiBaseUrl, prefix]);

  return { source, knownFolder, loading, error, refresh };
}
